import { __extends } from "tslib";
import { Info } from './Info';
var ScriptInfo = /** @class */ (function (_super) {
    __extends(ScriptInfo, _super);
    function ScriptInfo(abc, initializer, traits) {
        var _this = _super.call(this) || this;
        _this.abc = abc;
        _this.initializer = initializer;
        _this.traits = traits;
        _this.global = null;
        _this.state = 0 /* None */;
        return _this;
    }
    ScriptInfo.prototype.getInitializer = function () {
        if (this.initialiser) {
            return this.initialiser;
        }
        this.initialiser = this.abc.getMethodInfo(this.initializer);
        this.initialiser.scriptInfo = this;
        return this.initialiser;
    };
    ScriptInfo.prototype.trace = function (writer) {
        writer.enter('ScriptInfo');
        this.traits.trace(writer);
        writer.outdent();
    };
    return ScriptInfo;
}(Info));
export { ScriptInfo };
